/**
 * @generated SignedSource<<99fa03c1cef2fb84738f2395b015fc00>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HubStatus = "OFFLINE" | "ONLINE" | "%future added value";
export type SpaceConfiguration = "BACE_CLATTERING_STANDARD" | "BACE_SATELLITE_LARGE_EXTENDED" | "BACE_SATELLITE_LARGE_STANDARD" | "BACE_SATELLITE_MEDIUM_EXTENDED" | "BACE_SATELLITE_MEDIUM_STANDARD" | "BACE_SATELLITE_SMALL_EXTENDED" | "BACE_SATELLITE_SMALL_SLIM" | "BACE_SATELLITE_SMALL_STANDARD" | "BACE_STOREFRONT_2XL" | "BACE_STOREFRONT_L" | "BACE_STOREFRONT_M" | "BACE_STOREFRONT_S" | "BACE_STOREFRONT_XL" | "BACE_TRUCK_HUB_STANDARD" | "THALIA_RENZ_STANDARD_M" | "THALIA_RENZ_STANDARD_S" | "THALIA_RENZ_STANDARD_XS" | "THALIA_RENZ_WIDE_M" | "THALIA_RENZ_WIDE_S" | "%future added value";
export type selectMyLocksQuery$variables = {
  hubName: string;
};
export type selectMyLocksQuery$data = {
  readonly hubMeta: {
    readonly hub: {
      readonly availableConfigurations: ReadonlyArray<{
        readonly configuration: SpaceConfiguration;
        readonly dimensions: {
          readonly depthMm: number;
          readonly heightMm: number;
          readonly widthMm: number;
        };
        readonly numSpaces: number;
        readonly spaces: ReadonlyArray<{
          readonly id: string;
        }>;
      }>;
      readonly id: string;
      readonly status: HubStatus;
    };
    readonly id: string;
    readonly name: string;
  };
};
export type selectMyLocksQuery = {
  response: selectMyLocksQuery$data;
  variables: selectMyLocksQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubName"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "hubName"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Hub",
  "kind": "LinkedField",
  "name": "hub",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AvailableSpaceConfiguration",
      "kind": "LinkedField",
      "name": "availableConfigurations",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numSpaces",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "configuration",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "OutputDimensions",
          "kind": "LinkedField",
          "name": "dimensions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "widthMm",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "heightMm",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "depthMm",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Space",
          "kind": "LinkedField",
          "name": "spaces",
          "plural": true,
          "selections": [
            (v2/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Int"
},
v6 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UUID"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "selectMyLocksQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "HubMeta",
          "kind": "LinkedField",
          "name": "hubMeta",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v3/*:: as any*/),
            {
              "kind": "RequiredField",
              "field": (v4/*:: as any*/),
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "selectMyLocksQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1ff40395b726e03072444957a413ec46",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "hubMeta": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "HubMeta"
        },
        "hubMeta.hub": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Hub"
        },
        "hubMeta.hub.availableConfigurations": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "AvailableSpaceConfiguration"
        },
        "hubMeta.hub.availableConfigurations.configuration": {
          "enumValues": [
            "BACE_STOREFRONT_S",
            "BACE_STOREFRONT_M",
            "BACE_STOREFRONT_L",
            "BACE_STOREFRONT_XL",
            "BACE_STOREFRONT_2XL",
            "BACE_SATELLITE_SMALL_STANDARD",
            "BACE_SATELLITE_SMALL_SLIM",
            "BACE_SATELLITE_SMALL_EXTENDED",
            "BACE_SATELLITE_MEDIUM_STANDARD",
            "BACE_SATELLITE_MEDIUM_EXTENDED",
            "BACE_SATELLITE_LARGE_STANDARD",
            "BACE_SATELLITE_LARGE_EXTENDED",
            "BACE_CLATTERING_STANDARD",
            "BACE_TRUCK_HUB_STANDARD",
            "THALIA_RENZ_STANDARD_XS",
            "THALIA_RENZ_STANDARD_S",
            "THALIA_RENZ_STANDARD_M",
            "THALIA_RENZ_WIDE_S",
            "THALIA_RENZ_WIDE_M"
          ],
          "nullable": false,
          "plural": false,
          "type": "SpaceConfiguration"
        },
        "hubMeta.hub.availableConfigurations.dimensions": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "OutputDimensions"
        },
        "hubMeta.hub.availableConfigurations.dimensions.depthMm": (v5/*:: as any*/),
        "hubMeta.hub.availableConfigurations.dimensions.heightMm": (v5/*:: as any*/),
        "hubMeta.hub.availableConfigurations.dimensions.widthMm": (v5/*:: as any*/),
        "hubMeta.hub.availableConfigurations.numSpaces": (v5/*:: as any*/),
        "hubMeta.hub.availableConfigurations.spaces": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "Space"
        },
        "hubMeta.hub.availableConfigurations.spaces.id": (v6/*:: as any*/),
        "hubMeta.hub.id": (v6/*:: as any*/),
        "hubMeta.hub.status": {
          "enumValues": [
            "ONLINE",
            "OFFLINE"
          ],
          "nullable": false,
          "plural": false,
          "type": "HubStatus"
        },
        "hubMeta.id": (v6/*:: as any*/),
        "hubMeta.name": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "String"
        }
      }
    },
    "name": "selectMyLocksQuery",
    "operationKind": "query",
    "text": "query selectMyLocksQuery(\n  $hubName: String!\n) {\n  hubMeta(by: {name: $hubName}) {\n    id\n    name\n    hub {\n      id\n      status\n      availableConfigurations {\n        numSpaces\n        configuration\n        dimensions {\n          widthMm\n          heightMm\n          depthMm\n        }\n        spaces {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3ef05feb498daa56b151e01b74b1a80e";

export default node;
